module.exports = __webpack_public_path__ + "img/developcu.31668a80.png";